import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';

@Pipe({
    name: 'formatBookingDates',
})
export class FormatBookingDatesPipe implements PipeTransform {
    constructor(private router: Router) {}

    transform(startDateString: string, endDateString: string): string {
        const startDate = new Date(startDateString);
        const endDate = new Date(endDateString);

        const language = this.router.url.includes('/es') ? 'es' : 'en';

        const months = {
            en: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December',
            ],
            es: [
                'Enero',
                'Febrero',
                'Marzo',
                'Abril',
                'Mayo',
                'Junio',
                'Julio',
                'Agosto',
                'Septiembre',
                'Octubre',
                'Noviembre',
                'Diciembre',
            ],
        };

        const formattedStartDate =
            language === 'es'
                ? `${startDate.getDate()} de ${months.es[startDate.getMonth()]} del ${startDate.getFullYear()}`
                : `${months.en[startDate.getMonth()]} ${startDate.getDate()}, ${startDate.getFullYear()}`;

        const formattedEndDate =
            language === 'es'
                ? `${endDate.getDate()} de ${months.es[endDate.getMonth()]} del ${endDate.getFullYear()}`
                : `${months.en[endDate.getMonth()]} ${endDate.getDate()}, ${endDate.getFullYear()}`;

        return language === 'es'
            ? `${formattedStartDate} al ${formattedEndDate}`
            : `${formattedStartDate} to ${formattedEndDate}`;
    }
}
